import { useEffect, useState } from 'react'
import { PageHeader } from '@/components/layout/PageHeader'
import { useAppAuth } from '@/contexts/app-auth.context'
import { useDocumentHead } from '@/hooks/use-document-head'
import { UsersManagement } from '@workos-inc/widgets'

export function UsersPage() {
  const { getAccessToken } = useAppAuth()
  const [accessToken, setAccessToken] = useState<string | null>(null)

  useDocumentHead({
    title: 'Users',
    description: "Manage your organization's users, roles, and permissions",
  })

  useEffect(() => {
    const fetchToken = async () => {
      const token = await getAccessToken()
      setAccessToken(token)
    }
    fetchToken()
  }, [getAccessToken])

  return (
    <div className="space-y-6 p-6 pt-0">
      <PageHeader title="Manage your organization's users, roles, and permissions" />

      <div className="bg-card">
        {accessToken ? (
          <UsersManagement authToken={accessToken} />
        ) : (
          <div className="p-6">
            <div className="text-center">
              <p className="text-muted-foreground">Loading...</p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
